module.exports = __webpack_public_path__ + "media/src/application/media/route_4-7764daf889421b0c3454c70d39d2e624.webp";